import { Context, CustomQuery } from '@vue-storefront/core';
import { WishAdd, ApiResult } from '../../types';

export default async function wishAdd({ client, config }: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/fav/add', config.api.url);
  const x = { good_id: params.goodId, sku_id: params.skuId };
  // console.log("-------------------------", params, x)
  const { data: res } = await client.post(url.href, x);
  // console.log("++++++++++++++++++++++++++", res.data)

  const WishAdd: WishAdd = {
    data: res.data
  };
  res.data = WishAdd;
  return res;
}
